/**
 * Header & SHOP mega menu — Phase 2 native rebuild (5 Aug 2026), sticky header added 10 Aug 2026
 * Vanilla JS (no jQuery dependency) so it doesn't need to wait on jQuery's own
 * lazyload in layout/theme.liquid. Handles: SHOP panel open/close (click, Escape,
 * click-outside, focus-first-link-on-open), mobile Shop accordion, the
 * homepage transparent-to-solid header transition on scroll, and mobile smart-sticky
 * (hide on scroll down, show on scroll up - see snippets/custom-css.liquid for the sticky
 * positioning itself, which is CSS-only).
 */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* ---------- Desktop SHOP mega panel ---------- */
    var shopTab = document.getElementById("ShopMegaMenuTrigger");
    var megaPanel = document.getElementById("ShopMegaMenuPanel");
    var closeBtn = document.getElementById("ShopMegaMenuClose");

    if (shopTab && megaPanel) {
      /* 10 Aug 2026 - real bug found (pre-existing since the panel was first built, not caused
         by any recent change - confirmed present on both Claude copy and live once actually
         tested): the homepage hero carousel (Owl Carousel, jQuery plugin) kept auto-advancing
         behind the open panel, since nothing ever told it to stop. Owl Carousel's own API is
         event-based via jQuery ($carousel.trigger('stop.owl.autoplay')) - this file is
         deliberately vanilla JS with no jQuery dependency (see file header), but jQuery IS used
         elsewhere in this theme for owlCarousel itself, so it's safe to reach for window.jQuery
         here specifically - by the time a user actually clicks the SHOP tab (an interaction,
         not page load), jQuery has near-certainly finished its own lazy-load already. Guarded
         with a typeof check regardless, in case it hasn't for some reason - the guard just skips
         the pause/resume rather than throwing, so the panel itself still opens correctly either way. */
      var pauseHeroCarousel = function (shouldPause) {
        if (typeof window.jQuery === "undefined") return;
        var $carousel = window.jQuery(".ishislideshow-carousel.owl-carousel");
        if (!$carousel.length) return;
        $carousel.trigger(shouldPause ? "stop.owl.autoplay" : "play.owl.autoplay");
      };

      /* 10 Aug 2026 - the CSS-only fix (max-height: calc(100vh - 100px)) turned out not to be
         enough: it doesn't account for how far down the panel's own top position already sits
         (varies with announcement bar height, sticky/scrolled state, etc.) - a panel starting
         200px down the page with an 800px max-height still lands 100px past the bottom of a
         900px viewport, regardless of the panel's own internal scroll. Fixed by measuring the
         panel's REAL position at the moment it opens and setting an exact pixel max-height from
         there to the bottom of the viewport (with a small buffer) - robust regardless of scroll
         position or header state, unlike a fixed CSS guess. Cleared back to '' on close so the
         base #ShopMegaMenuPanel rule's own max-height:0 can take over for the close animation -
         leaving the inline value in place would override that and break the collapse. */
      var updatePanelMaxHeight = function () {
        var top = megaPanel.getBoundingClientRect().top;
        var available = window.innerHeight - top - 24;
        megaPanel.style.maxHeight = Math.max(available, 200) + "px";
      };

      var toggleShop = function (open) {
        var next = typeof open === "boolean" ? open : !megaPanel.classList.contains("is-open");
        if (next) updatePanelMaxHeight();
        megaPanel.classList.toggle("is-open", next);
        megaPanel.setAttribute("aria-hidden", String(!next));
        shopTab.setAttribute("aria-expanded", String(next));
        pauseHeroCarousel(next);
        if (next) {
          var firstLink = megaPanel.querySelector("a[href]");
          // 2 Nov 2026: preventScroll + scrollTop reset - focusing while the panel expands scrolled
          // it internally on short screens, hiding the Price Band row at the top.
          megaPanel.scrollTop = 0;
          if (firstLink) firstLink.focus({ preventScroll: true });
        } else {
          megaPanel.style.maxHeight = "";
        }
      };

      shopTab.addEventListener("click", function () {
        toggleShop();
      });

      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          toggleShop(false);
          shopTab.focus();
        });
      }

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && megaPanel.classList.contains("is-open")) {
          toggleShop(false);
          shopTab.focus();
        }
      });

      /* 9 Aug 2026 - preventDefault added: without it, a click outside the panel (e.g. on the
         hero slideshow behind it) closed the panel AND still activated whatever was under the
         click - the slideshow's own link, navigating the user away. The panel sits on top
         visually (z-index), but the click still reaches the element underneath unless stopped. */
      document.addEventListener("click", function (e) {
        if (!megaPanel.classList.contains("is-open")) return;
        if (megaPanel.contains(e.target) || shopTab.contains(e.target)) return;
        e.preventDefault();
        toggleShop(false);
      }, true);
    }

    /* ---------- Mobile Shop accordion ---------- */
    var mShopBtn = document.getElementById("MobileShopAccordionBtn");
    var mShopBody = document.getElementById("MobileShopAccordionBody");
    if (mShopBtn && mShopBody) {
      mShopBtn.addEventListener("click", function () {
        var next = !mShopBody.classList.contains("open");
        mShopBody.classList.toggle("open", next);
        mShopBtn.setAttribute("aria-expanded", String(next));
      });
    }

    /* ---------- Mobile fixed-header spacer (non-home pages only) ----------
       10 Aug 2026 - .header_main_in switches from sticky (desktop) to fixed (mobile, see
       snippets/custom-css.liquid) to avoid a run of sticky-specific WebKit bugs. Unlike sticky,
       fixed removes the element from normal document flow immediately on load, which would
       otherwise make page content jump up underneath it by the header's own height. This spacer
       reserves that space. Homepage doesn't need one - its header was already out of flow via
       position:absolute even before switching to fixed on scroll, so there's nothing new to
       compensate for there. Re-measured on resize/orientation change since the header's real
       height can vary (announcement bar height, font loading, etc). */
    var headerWrap = document.querySelector(".header_main_in");
    if (headerWrap && !document.body.classList.contains("template-index")) {
      var headerSpacer = document.createElement("div");
      headerSpacer.className = "header-fixed-spacer";
      headerWrap.parentNode.insertBefore(headerSpacer, headerWrap.nextSibling);

      var updateSpacerHeight = function () {
        if (window.matchMedia("(max-width: 991px)").matches) {
          headerSpacer.style.height = headerWrap.offsetHeight + "px";
        } else {
          headerSpacer.style.height = "0px";
        }
      };
      updateSpacerHeight();
      window.addEventListener("resize", updateSpacerHeight);
    }

    /* ---------- Homepage transparent-to-solid header on scroll ---------- */
    var header = document.getElementById("header");
    if (header && document.body.classList.contains("template-index")) {
      var THRESHOLD = 60;
      var setScrolled = function () {
        header.classList.toggle("is-scrolled", window.scrollY > THRESHOLD);
      };
      setScrolled();
      window.addEventListener("scroll", setScrolled, { passive: true });
    }

    /* ---------- Desktop compact header on scroll (26 Aug 2026, Cellar Log #23 sub-thread) ----------
       Sitewide (unlike is-scrolled above, which is homepage-only), desktop-only compact treatment:
       promo bar (#qab_container - a third-party app embed, not part of this theme's own markup, so
       handled via :has() in CSS rather than assumed here) and the utility row collapse, the logo
       swaps to a slim wordmark, main row tightens. Toggled unconditionally here (cheap) and scoped
       to desktop widths entirely via CSS (min-width: 992px, snippets/custom-css.liquid) - same
       "toggle in JS regardless, scope the visual effect in CSS" pattern as the mobile hide/reveal
       below, so no matchMedia check is needed. A fresh listener rather than piggybacking on
       is-scrolled above, since that one is deliberately homepage-only and this isn't. */
    if (header) {
      var COMPACT_THRESHOLD = 40;
      var wasCompact = header.classList.contains("is-compact");
      var setCompact = function () {
        var nowCompact = window.scrollY > COMPACT_THRESHOLD;
        header.classList.toggle("is-compact", nowCompact);
        if (nowCompact !== wasCompact) {
          wasCompact = nowCompact;
          /* 16 Sep 2026 - on mobile the header is position:fixed with a JS-measured spacer
             (see updateSpacerHeight above), not sticky like desktop. Once #qab_container's
             compact-mode collapse (snippets/custom-css.liquid, extended to mobile the same
             day to fix the promo-bar/header overlap bug) shrinks the real header, the spacer
             was still reserving its old, taller pre-collapse height - leaving a visible gap
             between the header and whatever comes after it (e.g. the breadcrumb bar).
             Re-measuring only on the is-compact flip (not every scroll tick) keeps this
             cheap. First attempt used a 300ms setTimeout to let the CSS collapse's own
             transition finish first - confirmed via a second screen recording that this
             just moved the bug: for ~0.5s mid-transition the real header and the spacer
             disagreed, visibly jumping/blanking the breadcrumb bar. Once the collapse
             itself became instant (transition removed in the CSS, same file/date), there's
             no transition left to wait out - a single next-frame measurement is already
             accurate, so requestAnimationFrame replaces the timeout. No-op on desktop -
             updateSpacerHeight already zeroes the spacer there since sticky doesn't need
             one. */
          requestAnimationFrame(function () {
            if (typeof updateSpacerHeight === "function") updateSpacerHeight();
          });
        }
      };
      setCompact();
      window.addEventListener("scroll", setCompact, { passive: true });
    }

    /* ---------- Mobile smart sticky: hide on scroll down, show on scroll up ----------
       10 Aug 2026 (brief: curatedwines_phase2_refinements_brief.md Task 1). The CSS effect
       (transform: translateY(-100%)) is media-scoped to mobile only, so this can run
       unconditionally here without a matchMedia check - toggling the class on desktop is
       harmless since no CSS rule there gives it a visual effect. rAF-throttled so rapid scroll
       events don't run the class-toggle logic more than once per frame. HIDE_THRESHOLD keeps
       the header visible near the very top of the page, avoiding hide/show flicker from tiny
       scroll jitters right after load.
       Class toggles on <body>, not #header - a real mobile bug (header vanishing on scroll
       down, only partially reappearing on scroll up) traced to iOS WebKit losing track of
       sticky/fixed state when transform was applied directly to #header while an ancestor also
       carried the position:sticky/fixed rule. <body> is never itself positioned, so it can't
       conflict - the CSS (snippets/custom-css.liquid) now applies the actual transform to
       whichever element carries the real position rule in each template. */
    if (header) {
      var lastScrollY = window.scrollY;
      var HIDE_THRESHOLD = 80;
      var ticking = false;

      var updateHeaderVisibility = function () {
        var currentScrollY = window.scrollY;
        if (currentScrollY <= HIDE_THRESHOLD) {
          document.body.classList.remove("header-is-hidden");
        } else if (currentScrollY > lastScrollY) {
          document.body.classList.add("header-is-hidden");
        } else if (currentScrollY < lastScrollY) {
          document.body.classList.remove("header-is-hidden");
        }
        lastScrollY = currentScrollY;
        ticking = false;
      };

      window.addEventListener("scroll", function () {
        if (!ticking) {
          window.requestAnimationFrame(updateHeaderVisibility);
          ticking = true;
        }
      }, { passive: true });
    }
  });
})();
